<main class="l-central" ref="scrollContainer">
    <slot/>
</main>
